import { Trophy, type LucideIcon } from "lucide-react";
import type { ProgramPageIcon } from "@/types/programPage";
import { PAGE_ICONS } from "./pageIcons";

/** A lucide icon by stored name; falls back so a retired name never crashes. */
export function LucideByName({
  name,
  className,
  fallback = Trophy,
}: {
  name: string;
  className?: string;
  fallback?: LucideIcon;
}) {
  const Icon = PAGE_ICONS[name] ?? fallback;
  return <Icon className={className} aria-hidden />;
}

/** Any of the three icon kinds, sized by the font-size of `className`. */
export function PageIcon({
  icon,
  className = "",
}: {
  icon: ProgramPageIcon | null;
  className?: string;
}) {
  if (!icon) return null;
  if (icon.kind === "emoji") {
    return (
      <span className={`inline-block leading-none ${className}`} aria-hidden>
        {icon.value}
      </span>
    );
  }
  if (icon.kind === "image") {
    return (
      <img
        src={icon.value}
        alt=""
        loading="lazy"
        className={`inline-block h-[1em] w-[1em] object-contain ${className}`}
      />
    );
  }
  return <LucideByName name={icon.value} className={`inline-block h-[1em] w-[1em] ${className}`} />;
}
